import { render, staticRenderFns } from "./drag.vue?vue&type=template&id=4b2d2788&scoped=true&"
import script from "./drag.vue?vue&type=script&lang=js&"
export * from "./drag.vue?vue&type=script&lang=js&"
import style0 from "./drag.vue?vue&type=style&index=0&id=4b2d2788&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2d2788",
  null
  
)

export default component.exports